// we are importing 'as' because we use the same structure for all connection names
import { connectionName as wkoConnectionName } from '@owc/connection-wko-manager';
import { WKOListener } from '@/packages/_types/WKO';
import { store } from '@/store';

const onWKOChange = (listener: WKOListener) => {
  store.subscribe(wkoConnectionName, listener);
};

const unSubscribe = (listener: WKOListener) => {
  store.unsubscribe(wkoConnectionName, listener);
};

const mixin = {
  methods: {
    onWKOChange,
    unSubscribe,
  },
};

export default mixin;
